import React, { ReactElement, useState } from 'react'
import Logo from './logo'
import * as s from './styles'
import { CentralizedContent } from './styles'
interface Props {
  'data-qa'?: string
  children: JSX.Element
  logo?: string | boolean
  svg?: object
  urlLogo?: string
  onClick?: Function
  centralizedContent?: ReactElement
}

export const navbarContextProps = {
  openSubmenuId: null,
  setOpenSubmenuId: (_uuid: string) => {},
}

export const NavbarContext = React.createContext(navbarContextProps)

const Navbar: React.FC<any> = ({
  logo,
  svg,
  urlLogo,
  centralizedContent,
  onClick,
  children,
  ...rest
}: Props): JSX.Element => {
  const showLogo = !!logo && !svg
  const showSvg = !!svg && !logo
  const [openSubmenuId, setOpenSubmenuId] = useState(null)

  return (
    <NavbarContext.Provider
      data-qa={rest['data-qa']}
      value={{
        openSubmenuId: openSubmenuId,
        setOpenSubmenuId: (uuid) => setOpenSubmenuId(uuid),
      }}
    >
      <s.Navbar>
        {showLogo && (
          <s.ContainerLogo
            data-qa={rest['data-qa'] && `${rest['data-qa']}-logo`}
          >
            <s.Link
              onClick={() => onClick()}
              href={urlLogo}
              data-qa={rest['data-qa'] && `${rest['data-qa']}-link`}
            >
              {logo && <Logo logo={logo} />}
            </s.Link>
          </s.ContainerLogo>
        )}

        {showSvg && (
          <s.ContainerLogo>
            <s.Link
              onClick={() => onClick()}
              href={urlLogo}
              data-qa={rest['data-qa'] && `${rest['data-qa']}-link`}
            >
              {svg && <Logo svg={svg} />}
            </s.Link>
          </s.ContainerLogo>
        )}

        <CentralizedContent>{centralizedContent}</CentralizedContent>

        <s.Menu data-qa={rest['data-qa'] && `${rest['data-qa']}-menu`}>
          {children}
        </s.Menu>
      </s.Navbar>
    </NavbarContext.Provider>
  )
}

export default Navbar
